import React, { useState } from "react";
import { useGetVideosQuery } from "../../../features/Admin/Videos/videosApi";
import VideoPlayer from "./VideoPlayer";
import VideoList from "./VideoList";
import Loading from "../../../components/Ui/Loading";
import Error from "../../../components/Ui/Error";
import { useDispatch } from "react-redux";
import { clickedVideo } from "../../../features/Student/CoursePlayer/coursePlayerSlice";
import AssignmentModal from "./AssignmentModal";

export default function CoursePlayer() {
  // *****************************************************DECLARATION START******************************************************************************
  const {
    data: videos,
    isLoading: videosIsLoading,
    isError: videosIsError,
  } = useGetVideosQuery();
  const dispatch = useDispatch();

  const [modalIsOpen, setModalIsOpen] = useState(false);
  // *****************************************************DECLARATION END******************************************************************************
  // *****************************************************useEffect START******************************************************************************
  // *****************************************************useEffect END******************************************************************************
  // *****************************************************HANDLE START******************************************************************************
  const clickedVideoToPlay = (id, title) => {
    dispatch(clickedVideo({ id, title }));
  };
  const closeModal = () => {
    setModalIsOpen(false);
  };

  // *****************************************************HANDLE END******************************************************************************
  // *****************************************************Decided which part render START******************************************************************************
  let videoListContent = null;
  let videoPlayerContent = null;

  if (videosIsLoading) {
    videoListContent = <Loading />;
    videoPlayerContent = <Loading />;
  } else if (!videosIsLoading && videosIsError) {
    videoListContent = (
      <Error
        header="Error !!"
        message="System error contact with administrator"
      />
    );
    videoPlayerContent = (
      <Error
        header="Error !!"
        message="System error contact with administrator"
      />
    );
  } else if (!videosIsLoading && !videosIsError && videos?.length === 0) {
    videoListContent = <Error header="" message="No video available" />;
    videoPlayerContent = <Error header="" message="No video available" />;
  } else if (!videosIsLoading && !videosIsError && videos?.length > 0) {
    videoListContent = videos.map((row, index) => (
      <VideoList
        row={row}
        key={`${row?.id}_${index}`}
        clickedVideoToPlay={clickedVideoToPlay}
      />
    ));
    videoPlayerContent = (
      <VideoPlayer videos={videos[0]} setModalIsOpen={setModalIsOpen} />
    );
  }
  // *****************************************************Decided which part render END******************************************************************************

  return (
    <>
      <div className="grid grid-cols-3 gap-2 lg:gap-8">
        <div className="col-span-full w-full space-y-8 lg:col-span-2">
          {videoPlayerContent}
        </div>
        <div className="col-span-full lg:col-auto max-h-[570px] overflow-y-auto bg-secondary p-4 rounded-md border border-slate-50/10 divide-y divide-slate-600/30">
          {videoListContent}
        </div>
      </div>
      {modalIsOpen && (
        <AssignmentModal modalIsOpen={modalIsOpen} closeModal={closeModal} />
      )}
    </>
  );
}
